import classes from './checksCard.module.scss';
import cn from 'classnames';
import { getEllapsedTime, getRemainingTime } from '../../../Common/Timer.js';
import { LABEL } from '../../../../../../veriables';
import { ReactComponent as PaidIcon } from '@assets/images/Fireboard/paid.svg';
import { ReactComponent as Guest } from '@assets/images/Fireboard/guest.svg';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const PaymentDetails = item => {
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const check = item.check;
  return (
    <div className="d-flex justify-content-between align-items-center pt-2">
      <div>
        {FLABEL().CHECK_TOTAL}: {currenySymbol}
        {check?.totalAmount?.toFixed(2)}
      </div>

      <div className={cn(classes.unpaidContainer)}>
        {check?.paymentDetails?.unpaidAmount === check?.totalAmount ? (
          <span className={cn('rounded-pill fw-600', classes.unPaidPill)}>
            <span className={classes.iconContainer}>
              <PaidIcon />
            </span>
            <span className="d-flex align-items-center">{FLABEL().CHECK_UNPAID}</span>
          </span>
        ) : check?.paymentDetails?.unpaidAmount > 0 ? (
          <span className={cn('rounded-pill fw-600', classes.partialPaidPill)}>
            {`${currenySymbol}${check?.paymentDetails?.unpaidAmount?.toFixed(
              2
            )}`}
          </span>
        ) : (
          <>
            {check?.totalAmount > 0 ? (
              <span className={cn('rounded-pill', classes.paidPill)}>
                <span className={classes.iconContainer}>
                  <PaidIcon />
                </span>
                <span className="fw-600 d-flex align-items-center">{FLABEL().CHECK_PAID}</span>
              </span>
            ) : (
              <span className={cn('rounded-pill fw-600', classes.unPaidPill)}>
                {`${currenySymbol}${check?.paymentDetails?.unpaidAmount?.toFixed(
                  2
                )}`}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const DefaultContent = ({ check, isVenue }) => {
  const { timer, color } = getEllapsedTime(check?.ellapsedTime) || { timer: null, color: null };

  return (
    <div className="p-2">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div className="d-flex col-6 px-0">
          <span>#</span>
          <div className={cn(classes.checkTruncate, 'px-0 text-left')}>
            {check.number}
          </div>
        </div>
        {isVenue && (
          <div className="col-6 pr-0 pl-1 text-truncate">{check?.storeInfoDetails?.storeName}</div>
        )}
      </div>
      <div className={classes.PhoneIcon}>
        <span>{check.orderDetails?.phoneNumber || '---'}</span>
      </div>
      <div className="text-truncate col px-0">{check?.employeeFirstName || '---'}</div>
      <div className="d-flex justify-content-between align-items-center">
        <span>
          {FLABEL().CHECK_DUE} : {check.timeDetails?.dueDate}
        </span>
        <div
          className={cn(
            classes.timerText,
            'rounded d-flex justify-content-center align-items-center'
          )}
        >
          <span style={{ color: color, '--ellapsed-color': color }}>
            {timer}
          </span>
        </div>
      </div>

      <PaymentDetails check={check} />
    </div>
  );
};

const OnPremiseContent = ({ check, isVenue }) => {
  const { timer, color } = getEllapsedTime(check?.ellapsedTime) || { timer: null, color: null };
  return (
    <div className="p-2">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div className="d-flex col-6 px-0">
          <span>#</span>
          <div className={cn(classes.checkTruncate, 'px-0 text-left')}>
            {check.number}
          </div>
        </div>
        {isVenue && (
          <div className="col-6 pr-0 pl-1 text-truncate">{check?.storeInfoDetails?.storeName}</div>
        )}
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className={classes.PhoneIcon}>
          <span>{check.orderDetails?.phoneNumber || '---'}</span>
        </div>
        <div className={classes.PhoneIcon}>
          <Guest /> : <span>{check.guestDetails?.guestCount}</span>
        </div>
      </div>
      <div className="text-truncate col px-0">{check?.employeeFirstName || '---'}</div>
      <div className="d-flex justify-content-between align-items-center">
        <span className="col-6 px-0 text-truncate">
          {FLABEL().CHECK_OPEN} : {check.openDateDetails?.openDate}
        </span>
        <div
          className={cn(
            classes.timerText,
            'rounded d-flex justify-content-center align-items-center'
          )}
        >
          <span style={{ color: color, '--ellapsed-color': color }}>
            {timer}
          </span>
        </div>
      </div>

      <PaymentDetails check={check} />
    </div>
  );
};

const TableDelivery = ({ check, isVenue }) => {
  const { timer, color } = getEllapsedTime(check?.ellapsedTime) || { timer: null, color: null };
  return (
    <div className={cn('p-2')}>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div className={cn('px-0 pl-1 text-truncate', isVenue ? 'col-6' : 'col-12')}>
          {check?.tabName || check?.orderDetails?.orderName || '---'}
        </div>
        {isVenue && (
          <div className="col-6 pr-0 pl-1 text-truncate">{check?.storeInfoDetails?.storeName}</div>
        )}
      </div>
      <div className="d-flex justify-content-between align-items-center">

        <div className="text-truncate col px-0 pr-2">{check?.employeeFirstName || '---'}</div>
        <div
          className={cn(
            classes.timerText,
            'rounded d-flex justify-content-center align-items-center'
          )}
        >
          <div style={{ color: color, '--ellapsed-color': color }}>
            {timer}
          </div>
        </div>
      </div>
      <div>
        {FLABEL().CHECK_OPEN} : {check.openDateDetails?.openDate}
      </div>
      <div>
        {FLABEL().CHECK_CLOSED} : {check.openDateDetails?.closeDate}
      </div>

      <PaymentDetails check={check} />
    </div>
  );
};

const OffPremiseContent = ({ check, isVenue }) => {
  const { timer, color } = getRemainingTime(check.remainingTimeDetails?.remainingTime) || { timer: null, color: null };
  return (
    <div className="p-2">
      {isVenue && <div className={cn('col-12 p-0 text-truncate')}>{check?.storeInfoDetails?.storeName}</div>}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div className="d-flex col-6 px-0 text-truncate">
          <span>#</span>
          <div className={cn(classes.checkTruncate, 'px-0 text-left')}>
            {check.number}
          </div>
        </div>
        {check?.checkedIn && (
          <div className={cn(classes.CheckedInChip, 'text-right')}>
            <span>Chk In</span>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div className={classes.PhoneIcon}>
          <span>{check.orderDetails?.phoneNumber || '---'}</span>
        </div>
        <div className='col-5 px-0 text-truncate text-right'>{check?.checkInNote}</div>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div>{FLABEL().CHECK_DUE} : {check.remainingTimeDetails?.dueDate}</div>
        <div
          className={cn(
            classes.timerText,
            'rounded d-flex justify-content-center align-items-center'
          )}
        >
          <span style={{ color: color, '--ellapsed-color': color }}>
            {timer}
          </span>
        </div>
      </div>
      <PaymentDetails check={check} />
    </div>
  );
};

const CardContentByMode = ({ check, mode, isVenue }) => {
  switch (mode) {
    case 'DEFAULT':
      return <DefaultContent check={check} isVenue={isVenue} />;
    case 'ON_PREMISE':
      return <OnPremiseContent check={check} isVenue={isVenue} />;
    case 'OFF_PREMISE':
      return <OffPremiseContent check={check} isVenue={isVenue} />;
    case 'TABLE_DELIVERY':
      return <TableDelivery check={check} isVenue={isVenue} />;
    default:
      return <DefaultContent check={check} />;
  }
};

export default CardContentByMode;
